import http from "./http-service";
import config from "../config/constant";

export const getLoanDetails = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "LOANSCALCULATOR",
      userName: 'TEST',
    };
    const response = await http.post(config.calculator.calLoanDep, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

export const getPwdCriteria = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "REGISTUSER",
    };
    const response = await http.post(
      config.forgotPassword.passwordCriteria,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

export const postChangePassword = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "REGISTUSER",
    };
    const response = await http.post(config.changePwd, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

export const getLastNTransactions = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "LASTNTRANSACTION",
    };
    const response = await http.post(
      config.userActions.lastNactivities,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

export const getBillerBeneficiariesDetails = async (data) => {
  try {
    const reqParams = {
      ...data,
      merchant: "",
      serviceId: "",
      serviceNumber: "",
      shortName: "",
      requestId: "REGISTUSER",
    };
    const response = await http.post(
      config.billers.getBillerBeneficiaries,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

export const getReciept = async (data) => {
  try {
    const reqParams = {
      ...data,
      fromDate: data.fromDate,
      toDate: data.toDate,
      requestId: "RECEIPT",
    };
    const response = await http.post(config.portfolio.getProofByRange, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

export const getSalaryStatus = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "REGISTUSER",
    };
    const response = await http.post(config.portfolio.salaryDownload, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

export function showFile(blob, fileName) {
  console.log(blob)
  const newBlob = new Blob([blob], { type: 'application/pdf' })
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob)
    return
  }
  const data = window.URL.createObjectURL(newBlob)
  const link = document.createElement('a')
  link.href = data
  link.download = `${fileName}.pdf`
  link.click()
  setTimeout(() => {
    window.URL.revokeObjectURL(data)
  }, 100)
}
export function showXlsxFile(blob, fileName) {
  console.log(blob)
  const newBlob = new Blob([blob], { type: 'application/xlsx' })
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob)
    return
  }
  const data = window.URL.createObjectURL(newBlob)
  const link = document.createElement('a')
  link.href = data
  link.download = `${fileName}`
  link.click()
  setTimeout(() => {
    window.URL.revokeObjectURL(data)
  }, 100)
}

export const pdfReceipt = async (data) => {
  try {
    const reqParams = {
      ...data,
      transRefNum: data.transRefNum,
      refId: data.refId,
      requestId: "REGISTUSER",
    };
    const response = await http.post(config.userActions.pdfreceipt, reqParams,{
      responseType: 'blob'});
    showFile(response.data, `Statement_${reqParams.transRefNum}`)
  } catch (err) {
    return Promise.reject(err);
  }
};

export const suStatusRecord = async (data) => {
  try {
    const reqParams = {
      ...data,
      reqId: data.reqId,
      requestId: "REGISTUSER",
    };
    const response = await http.post(config.userActions.suStatusRecord, reqParams,{
      responseType: 'blob'});
    //showFile(response.data, `Statement_${data.transTime}`)
    showXlsxFile(response.data, data.file)
  } catch (err) {
    return Promise.reject(err);
  }
};


export const LastNTransactions = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "RECEIPTDOWNLOAD",
    };
    const response = await http.post(
      config.userActions.lastNtxns,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const QuickLinkService = {
  getLoanDetails,
  getPwdCriteria,
  postChangePassword,
  getLastNTransactions,
  getBillerBeneficiariesDetails,
  getReciept,
  pdfReceipt,
  getSalaryStatus,
  suStatusRecord,
  LastNTransactions
};

export default QuickLinkService;
